import { CssBaseline } from '@mui/material';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReportCrashed from './components/ReportCrashed';
import ReportsApp from './ReportsApp';
import { initSentry } from './sentry';

// Before the first render, so an error thrown while mounting is reported too.
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <CssBaseline />
    {/* Sends the error with the component stack that threw it, and puts a
        message where React would otherwise leave a blank page. */}
    <Sentry.ErrorBoundary fallback={<ReportCrashed />}>
      <ReportsApp />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
